
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  layoutType: 'scss',
};

const layoutSlice = createSlice({
  name: 'layout',
  initialState,
  reducers: {
    toggleLayout: (state) => {
      state.layoutType = state.layoutType === 'scss' ? 'mui' : 'scss';
    },
    setLayout: (state, action) => {
      state.layoutType = action.payload;
    },
  },
});

export const { toggleLayout, setLayout } = layoutSlice.actions;
export default layoutSlice.reducer;
